import React, { useEffect, useState } from 'react';
import Presale from '../components/Presale';
import Navbar from '../components/Navbar';
import PresaleHistory from '../components/WalletInfo';
import Staking from '../components/Staking';
import Footer from '../components/Footer';
import TransactionHistory from '../components/TransactionsHistory';
import { 
  Chart as ChartJS, 
  ArcElement, 
  Tooltip, 
  Legend,
  DoughnutController
} from 'chart.js';

import { BrowserProvider, Contract } from 'ethers';
import { useWeb3ModalProvider } from "@web3modal/ethers/react";
import { usdtAddress, vendorAddress, stakeAddress, tokenAddress } from '../utils/contractAddress';
import { ethers } from 'ethers';
import usdtABI from "../utils/emeABI.json"
import vendorAbi from "../utils/VendorABI.json"
import stakeAbi from "../utils/StakeABI.json"
import tokenAbi from "../utils/emeABI.json";
import styled, { keyframes } from 'styled-components';

const twinkleAnimation = keyframes`
  0%, 100% { opacity: 0.15; }
  50% { opacity: 0.25; }
`;

const Container = styled.div`
  width: 100%;
  overflow-x: hidden;
  position: relative;
`;

const HeroSection = styled.section`
  background-image: url('https://www.themecrypto.it/wp-content/uploads/2025/03/Progetto-senza-titolo-1.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  max-width: 100vw;
`;

const BoostSection = styled.div`
  text-align: center;
  width: 100%;
  padding: 20px 0;
  
  h1 {
    margin: 0;
    color: #FFA500;
  }
`;

const TokenomicsContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  width: 95%;

  @media (max-width: 768px) {
    padding: 0 1rem;
    gap: 15px;
    width: auto;
  }
`;

const TokenomicsBox = styled.div`
  background: linear-gradient(145deg, 
    rgba(27, 27, 27, 0.95), 
    rgba(40, 40, 60, 0.98));
  border: 1px solid rgba(255, 165, 0, 0.1);
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.2),
    inset 0 1px 1px rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 20px;
  width: 300px;
  text-align: left;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    width: 100%;
    padding: 15px;
    margin: 0;
  }

  &:hover {
    transform: translateY(-5px);
    background: linear-gradient(145deg, 
      rgba(32, 32, 42, 0.98), 
      rgba(45, 45, 65, 0.98));
    box-shadow: 
      0 10px 40px rgba(0, 0, 0, 0.3),
      inset 0 1px 2px rgba(255, 255, 255, 0.1);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(1px 1px at 15% 15%, rgba(255, 255, 255, 0.8) 100%, transparent),
                radial-gradient(1.5px 1.5px at 35% 35%, rgba(255, 215, 0, 0.8) 100%, transparent),
                radial-gradient(1px 1px at 75% 75%, rgba(255, 255, 255, 0.9) 100%, transparent);
    opacity: 0.15;
    animation: ${twinkleAnimation} 4s ease-in-out infinite alternate;
    pointer-events: none;
    z-index: 0;
  }

  h3 {
    color: #ffa500;
    font-size: 1.2rem;
    margin-bottom: 10px;
    border-bottom: 1px solid rgba(255, 165, 0, 0.2);
    padding-bottom: 10px;
    position: relative;
    z-index: 1;

    @media (max-width: 768px) {
      font-size: 1.1rem;
      padding-bottom: 8px;
    }
  }

  p {
    color: rgba(255, 255, 255, 0.9);
    font-size: 0.9rem;
    margin: 0;
    line-height: 1.4;
    position: relative;
    z-index: 1;

    @media (max-width: 768px) {
      font-size: 0.85rem;
    }
  }
`;

const TokenomicsTitle = styled.h2`
  color: #6B4423;
  text-align: center;
  font-size: 2rem;
  margin-bottom: 2rem;
  width: 100%;
`;

const TokenomicsHeader = styled.div`
  background: linear-gradient(145deg, 
    rgba(27, 27, 27, 0.95), 
    rgba(40, 40, 60, 0.98));
  border: 1px solid rgba(255, 165, 0, 0.1);
  padding: 2rem;
  margin: 0 auto 2rem auto;
  max-width: 1200px;
  width: 95%;
  text-align: center;
  position: relative;
  overflow: hidden;
  border-radius: 16px;

  @media (max-width: 768px) {
    padding: 1.5rem;
    margin: 0 1rem 1.5rem 1rem;
    width: auto;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(1px 1px at 15% 15%, rgba(255, 255, 255, 0.8) 100%, transparent),
                radial-gradient(1.5px 1.5px at 35% 35%, rgba(255, 215, 0, 0.8) 100%, transparent),
                radial-gradient(1px 1px at 75% 75%, rgba(255, 255, 255, 0.9) 100%, transparent);
    opacity: 0.15;
    animation: ${twinkleAnimation} 4s ease-in-out infinite alternate;
    pointer-events: none;
    z-index: 0;
  }

  h1 {
    color: #ffa500;
    font-size: 2.5rem;
    margin-bottom: 1rem;
    position: relative;
    z-index: 1;
    background: linear-gradient(45deg, #ffd700, #ffa500, #ff8c00);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    @media (max-width: 768px) {
      font-size: 2rem;
      margin-bottom: 0.8rem;
    }
  }

  p {
    color: rgba(255, 255, 255, 0.9);
    font-size: 1.1rem;
    max-width: 800px;
    margin: 0 auto;
    position: relative;
    z-index: 1;

    @media (max-width: 768px) {
      font-size: 0.9rem;
      padding: 0 0.5rem;
    }
  }
`;

const Home = () => {

  const { walletProvider } = useWeb3ModalProvider();

  const [tokenContract, setTokenContract] = useState();
  const [usdtContract, setUSDTContract] = useState();
  const [vendorContract, setVendorContract] = useState();
  const [stakeContract, setStakeContract] = useState();
  const [publicVendorContract, setPublicContract] = useState()

  useEffect(() => {
    connect();
    initChart();
  }, [walletProvider])

  const connect = async() => {
    const provider = new ethers.JsonRpcProvider(
      "https://bsc.nodereal.io"
    );
    const publicContract = new Contract(vendorAddress, vendorAbi, provider);
      if(walletProvider) {
        const ethersProvider = new BrowserProvider(walletProvider);
        const signer = await ethersProvider.getSigner();
        const tokenC = new Contract( tokenAddress, tokenAbi, signer);
        const usdtC =  new Contract( usdtAddress, usdtABI, signer);
        const vendorC = new Contract ( vendorAddress, vendorAbi, signer);
        const stakeC = new Contract ( stakeAddress, stakeAbi, signer);
        setTokenContract(tokenC);
        setUSDTContract(usdtC);
        setVendorContract(vendorC);
        setStakeContract(stakeC);
      }
      setPublicContract(publicContract);
  }

  const initChart = () => {
    ChartJS.register(
      ArcElement, 
      Tooltip, 
      Legend,
      DoughnutController
    );
    const ctx = document.getElementById('tokenomicsChart');
    
    if (ctx) {
      new ChartJS(ctx, {
        type: 'doughnut',
        data: {
          labels: [
            'Assegnazione pubblica',
            'Fondo di sviluppo',
            'Eco-Fondo',
            'Team e consulenti',
            'Marketing & Partnerships'
          ],
          datasets: [{
            data: [50, 20, 15, 10, 5],
            backgroundColor: [
              '#FFA07A', // Arancione chiaro per Assegnazione pubblica
              '#8B4513', // Marrone per Fondo di sviluppo
              '#FFD700', // Giallo per Eco-Fondo
              '#DEB887', // Beige per Team e consulenti
              '#8B0000'  // Marrone scuro per Marketing
            ],
            borderWidth: 0
          }]
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: 'bottom',
              labels: {
                color: 'white',
                font: {
                  size: 14
                }
              }
            }
          },
          cutout: '70%'
        }
      });
    }
  };

  return (
    <Container>
      <Navbar vContract={vendorContract}></Navbar>
      <HeroSection>
        <Presale vContract = {vendorContract} uContract = {usdtContract} pvContract = {publicVendorContract}></Presale>
      </HeroSection>
      <PresaleHistory vContract={vendorContract}/>
      <TransactionHistory vContract={vendorContract}></TransactionHistory>
      <BoostSection>
        <h1>STAKE NOW. GIVE IT A BOOST!</h1>
      </BoostSection>
      <Staking sContract={stakeContract} tContract={tokenContract}></Staking>

      <TokenomicsHeader>
        <h1>Tokenomics</h1>
        <p> THEME TECHNOLOGY HAS A MAXIMUM TOTAL SUPPLY OF 130,250,000 TOKENS</p>
      </TokenomicsHeader>

      <TokenomicsContainer>
        <TokenomicsBox>
          <h3>Public Allocation (50%)</h3>
          <p>Distributed through initial offerings and staking rewards to promote widespread adoption.</p>
        </TokenomicsBox>

        <TokenomicsBox>
          <h3>Development Fund (20%)</h3>
          <p>Reserved for ongoing development, infrastructure maintenance, and technological advancements.</p>
        </TokenomicsBox>

        <TokenomicsBox>
          <h3>Eco-Fund (15%)</h3>
          <p>Dedicated to funding environmental projects and partnerships with ecological organizations.</p>
        </TokenomicsBox>

        <TokenomicsBox>
          <h3>Team and Advisors (10%)</h3>
          <p>Allocated to founders, team members, and advisors, with a vesting schedule to ensure long-term commitment.</p>
        </TokenomicsBox>

        <TokenomicsBox>
          <h3>Marketing & Partnerships (5%)</h3>
          <p>Used for promotional activities, community building, and establishing strategic partnerships.</p>
        </TokenomicsBox>
      </TokenomicsContainer>


      <div style={{
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '2rem'
      }}>
        <img src={require('../assets/grafico.png')} alt="Grafico distribuzione token" style={{
          maxWidth: '100%',
          height: 'auto'
        }} />
      </div>

      <Footer></Footer>
    </Container>
  );
};

export default Home;
